import { IconButton, HStack } from '@genial/components';
import { BoxRadius, Color, Spacing, Typography } from '@genial/design-tokens';
import { Text } from 'native-base';
import React from 'react';

import { useRedeemBatchTicketHeader } from '../../hooks/header';

interface HeaderProps {}

export const Header: React.FC<HeaderProps> = () => {
  const { handleGoBack } = useRedeemBatchTicketHeader();

  return (
    <HStack
      borderTopRadius={{ base: BoxRadius.md, lg: 0 }}
      alignItems="center"
      justifyContent="space-between">
      <HStack
        alignItems="center"
        space={{ base: Spacing['inline.xxxs'], sm: Spacing['inline.quarck'] }}>
        <IconButton
          testId="icon"
          icon="ArrowLeft"
          iconSize="xxs"
          p={0}
          backgroundColor="transparent"
          iconColor={Color['brand.primary.principal']}
          onPress={handleGoBack}
        />
        <Text variant="bold" fontSize={Typography['fontsize.lg']} color="neutral.black">
          Novo resgate
        </Text>
      </HStack>
      <IconButton
        testId="icon"
        icon="CloseModal"
        iconSize="xs"
        p={0}
        variant="rounded"
        borderWidth={0.05}
        backgroundColor="transparent"
        iconColor={Color['brand.primary.principal']}
        borderColor={Color['brand.primary.principal']}
        onPress={handleGoBack}
      />
    </HStack>
  );
};
